import MUIAccordion, { AccordionProps } from "@mui/material/Accordion";
import React, { FC } from "react";

export const Accordion: FC<AccordionProps> = (props) => <MUIAccordion {...props} />;
